import store from '@/store/store'
import router from '@/routes/router'

/**
 * Constant with error code from backend
 */
const UNAUTHORIZED_ERROR_CODE = 401;

/**
 * @description
 * Make actions before send axios request.
 * In this case, this function add bypass param to request if
 * the Vue Environment Var "VUE_APP_BY_PASS_LOGIN" is "true",
 * 
 * @param {Object} config 
 * @return {Object} config
 */
const beforeRequest = (config) => {
    // Do something before request is sent
    if(process.env.VUE_APP_BY_PASS_LOGIN === 'true')
    {
        if(config.params == undefined) config.params = {} // For query with Models
        config.params.bypass = true
    }

    return config;
};

/**
 * @description
 * Error request to backend,
 * 
 * @param {Object} response 
 * @return {Promise} response 
 */
const errorRequest = (error) => {
    return new Promise(function (resolve, reject) {
        if (error.response.status === UNAUTHORIZED_ERROR_CODE) {
            store.dispatch('AuthModule/logoutActions') // delete local storage user data
            router.push('/login')
        } 
        throw error
    });

}

export { beforeRequest, errorRequest }